import { tacticMap } from '../../../../../../../../../classes/tactics/tacticKeys';
import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';

export function targetHitButNegativePnlBuilder({parsedStatusObj}) {
  const { tacticName, target, currentPnl } = parsedStatusObj;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}> 
        {tacticName && tacticMap[tacticName]?.tacticLabel
          ? tacticMap[tacticName].tacticLabel
          : ''}{' '}
        {target ? '$' + ApplyRounding(Number(target), 2) : ''} target hit, but
        would result in a negative pnl. Current pnl:
        {currentPnl ? '$' + ApplyRounding(Number(currentPnl), 2) : 'unknown'}
      </Body3>
    </td>
  );
}
